var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 40,
    viewBox: "0 0 34 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9094 40H6.09126C3.09126 40 0.636719 37.5455 0.636719 34.5455V5.45455C0.636719 2.45455 3.09126 0 6.09126 0H20.6367C21.1276 0 21.5822 0.2 21.9276 0.527273L32.8367 11.4364C33.1822 11.7818 33.364 12.2364 33.364 12.7273V34.5455C33.364 37.5455 30.9094 40 27.9094 40ZM6.09126 3.63636C5.09126 3.63636 4.27308 4.45455 4.27308 5.45455V34.5455C4.27308 35.5455 5.09126 36.3636 6.09126 36.3636H27.9094C28.9094 36.3636 29.7276 35.5455 29.7276 34.5455V13.4727L19.8913 3.63636H6.09126Z",
    fill: "#8ACB23"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5458 14.5455H20.6367C19.6367 14.5455 18.8185 13.7273 18.8185 12.7273V1.81818C18.8185 0.818182 19.6367 0 20.6367 0C21.6367 0 22.4549 0.818182 22.4549 1.81818V10.9091H31.5458C32.5458 10.9091 33.364 11.7273 33.364 12.7273C33.364 13.7273 32.5458 14.5455 31.5458 14.5455Z",
    fill: "#8ACB23"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4549 27.2727H11.5458C10.5458 27.2727 9.72763 26.4545 9.72763 25.4545C9.72763 24.4545 10.5458 23.6364 11.5458 23.6364H22.4549C23.4549 23.6364 24.2731 24.4545 24.2731 25.4545C24.2731 26.4545 23.4549 27.2727 22.4549 27.2727Z",
    fill: "#8ACB23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocApproved);
export default __webpack_public_path__ + "static/media/docApproved.7a313d127b5216f0630c1ad1e26c9f61.svg";
export { ForwardRef as ReactComponent };